export default {
  'menu.workbench': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.template': 'テンプレート',
  'menu.reimbursements': '経費精算',
  'menu.reimbursements.dashboard': '精算ダッシュボード',
  'menu.reimbursements.invoices': '請求書収集',
  'menu.reimbursements.invoices.my': '自分の請求書',
  'menu.reimbursements.invoices.all': 'すべての請求書',
  'menu.reimbursements.claims': '申請書',
  'menu.reimbursements.claims.my': '自分の申請',
  'menu.reimbursements.claims.all': 'すべての申請',
  'menu.reimbursements.approval': '承認センター',
  'menu.reimbursements.claimEdit': '申請入力',
  'menu.reimbursements.analytics': 'データ集計分析',
  'menu.reimbursements.myAnalytics': '個人集計',
  'menu.reimbursements.managementCockpit': '管理ダッシュボード',
  'menu.reimbursements.financeAnalytics': '財務集計',
  'menu.reimbursements.specialAnalytics': '財務集計',
  'menu.reimbursements.analytics.reimbursements.myAnalytics': '個人集計',
  'menu.reimbursements.analytics.reimbursements.financeAnalytics': '財務集計',
  'menu.reimbursements.analytics.reimbursements.managementCockpit':
    '管理ダッシュボード',
  'menu.settings': '設定',
  'menu.settings.reimbursement': '経費精算設定',
  'menu.settings.anomalyRules': '異常ルール',
  'menu.settings.buyers': '購入者設定',
  'menu.settings.expenseCategories': '経費区分',
  'menu.settings.sceneTemplates': 'シーンテンプレート',
  'menu.settings.personalQuotaConfigs': '個人限度額',
  'menu.settings.expenseStandardPolicies': '費用標準',
  'menu.settings.permissions': '権限管理',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
